import { render, staticRenderFns } from "./recipient.vue?vue&type=template&id=0d8c7e4e&scoped=true&"
import script from "./recipient.vue?vue&type=script&lang=ts&"
export * from "./recipient.vue?vue&type=script&lang=ts&"
import style0 from "./recipient.vue?vue&type=style&index=0&id=0d8c7e4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8c7e4e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jonas/Projects/Risolto/operator-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d8c7e4e')) {
      api.createRecord('0d8c7e4e', component.options)
    } else {
      api.reload('0d8c7e4e', component.options)
    }
    module.hot.accept("./recipient.vue?vue&type=template&id=0d8c7e4e&scoped=true&", function () {
      api.rerender('0d8c7e4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/_invoice-disputes/recipient.vue"
export default component.exports